import React, { Component } from 'react';
import FilterModal from './Filters/FilterModal';
import FilterContactCenter from './Filters/FilterContactCenter';
import AddACC from './AddACC/AddACC';
import AddACCModal from './AddACC/AddACCModal';
import ContactCenterList from './ContactCenterList';
import Snackbar from '../../components/Snackbar';
import { connect } from 'react-redux';
import { Grid, Button } from '@material-ui/core';
import { filterAdminContactCenter } from '../../configs/environments/firebase/firebaseApp';
import { showLoading, hideLoading } from '../../store/actions/LoadingActions';
import { withStyles } from '@material-ui/styles';
import { compose } from 'recompose'

const styles = () => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    grid: {
        justifyContent: 'space-between',
        margin: '0 0 16px 40px',
        width: '87.4%',
    },
    title: {
        color: '#10587f',
        fontSize: 32,
        fontWeight: 'bold',
        margin: '15px 0 33px 0',
    },
    buttonsContainer: {
        display: 'flex',
        margin: '15px 0 0 0',
    },
    showAll: {
        width: 168,
        height: 40,
        borderRadius: 20,
        border: '1px solid #013957',
        textTransform: 'inherit',
        backgroundColor: 'transparent',
        color: '#013957',
        fontSize: 16,
        margin: '0 24px 0 0',
    },
    filterButton: {
        width: 120,
        height: 40,
        borderRadius: 20,
        border: '1px solid #013957',
        textTransform: 'inherit',
        backgroundColor: 'transparent',
        color: '#013957',
        fontSize: 16,
        margin: '0 24px 0 0',
    },
    filterIcon: {
        margin: '0 10px 0 0',
    },
    arrow: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
    },
    arrowText: {
        color: '#013957',
        fontSize: 14,
        margin: '0 0 0 5px',
        fontWeight: 'bold',
    },
    addACC: {
        width: 168,
        height: 40,
        borderRadius: 20, 
        textTransform: 'inherit',
        backgroundColor: '#013957',
        color: 'white',
        fontSize: 16,
        '&:hover': {
            backgroundColor: '#35b9b6',
        }
    },
})

class AdminContactCenter extends Component {

    state = {
        showFilter: true,
        flagEvery: false,
        openFilterModal: false,
        openAddACCModal: false,
        showAddACC: false,
        feedbackMessage: {
            open: false,
            message: '',
            variant: 'success',
        }
    }

    handleShowFilter = () => {
        const { showFilter } = this.state
        this.setState({
            showFilter: !showFilter
        })
    }

    handleOpenFilter = () => {
        this.setState({
            showFilter: true
        })
    }

    handleShowAddACC = (flag) => {
        this.setState({
            showAddACC: flag
        })
    }

    handleAddACCModal = () => {
        const { openAddACCModal } = this.state
        this.setState({
            openAddACCModal: !openAddACCModal
        })
    }

    searchEvery = async () => {
        const { showLoading, hideLoading } = this.props
        showLoading()
        try {
            const params = { page: 1, searchEvery: true }
            const res = await filterAdminContactCenter(params)
            console.log('res', res);
            this.setState({
                openFilterModal: false,
                showFilter: false,
                flagEvery: true,
                showAddACC: false,
            })
            hideLoading()
            return res
        } catch (error) {
            console.log(error);
            this.setState({
                openFilterModal: false,
                showFilter: false,
                flagEvery: true,
                showAddACC: false,
            })
            hideLoading()
        }
    }

    handleFlagEvery = (flag) => {
        this.setState({
            flagEvery: flag
        })
    }

    addACC = () => {
        const { showFilter } = this.state
        if (showFilter) {
            this.handleShowAddACC(true)     
        } else {
            this.handleAddACCModal()
        }
    }

    handleFilterModal = () => {
        const { openFilterModal } = this.state;
        this.setState({
            openFilterModal: !openFilterModal
        })
    }

    handleSnack = () => {
        const { feedbackMessage } = this.state;
        this.setState(prev => ({
            feedbackMessage: {
                ...prev.feedbackMessage,
                open: !feedbackMessage.open,
                message: '¡Listo! Usuario creado',
            }
        }))
    }

    render() {
        const { showFilter, openFilterModal, openAddACCModal, feedbackMessage, flagEvery, showAddACC } = this.state;
        const { classes } = this.props;
        // const testObject = {
        //     names: 'Abdiel Álvarez Rojas',
        //     email: 'roberto.ferrera1223@gmail.com',
        //     password: '0987654321',
        //     createBy: 'seVfumQbpMNHJi4Bd9vGXnhR8Dn2',
        //     uid: 'qfmM2If8Q8dgk6fTLnuDsOVdzu22'
        // }
        
        return (
            <div className={classes.container}>
                <Grid
                    container
                    direction='row'
                    className={classes.grid}
                >
                    {showAddACC ?
                       <div
                            className={classes.arrow}
                            onClick={() => this.handleShowAddACC(false)}
                        >
                            <img
                                src="/img/admin/arrow-back.svg"
                                alt="arrow-back"
                            />
                            <p className={classes.arrowText}>Regresar</p>
                        </div> :
                        <p className={classes.title}>
                            {flagEvery && !showFilter ?
                                'Usuarios contact center' :
                            showFilter ?
                                'Información de usuarios contact center' :
                                'Resultados de filtro'
                            }
                        </p>
                    }
                    
                    {!showAddACC ?
                        <div className={classes.buttonsContainer}>
                            {showFilter ?
                                <Button
                                    type="button"
                                    onClick={this.searchEvery}
                                    className={classes.showAll}
                                >
                                    Mostrar todos
                                </Button> :
                                <Button
                                    type="submit"
                                    onClick={this.handleFilterModal}
                                    className={classes.filterButton}
                                >
                                    <img
                                        src='/img/icons/filters.svg'
                                        alt='filter'
                                        className={classes.filterIcon}
                                    />
                                    Filtros
                                </Button>
                            }
                            <Button
                                type="button"
                                onClick={this.addACC}
                                className={classes.addACC}
                            >
                                Agregar ACC
                            </Button>
                        </div> : null
                    }
                </Grid>

                {showAddACC ?
                    <AddACC
                        searchEvery={this.searchEvery}
                        handleSnack={this.handleSnack}
                        // valuesToEdit={testObject}
                    /> :
                showFilter ?
                    <FilterContactCenter
                        handleShowFilter={this.handleShowFilter}
                        handleFlagEvery={this.handleFlagEvery}
                    /> :
                    <ContactCenterList />
                }

                <FilterModal
                    open={openFilterModal}
                    handleClose={this.handleFilterModal}
                    content={
                        <FilterContactCenter
                            isModal
                            showEvery
                            searchEvery={this.searchEvery}
                            handleClose={this.handleFilterModal}
                            handleFlagEvery={this.handleFlagEvery}
                        />
                    }
                />
                <AddACCModal
                    open={openAddACCModal}
                    handleClose={this.handleAddACCModal}
                    content={
                        <AddACC
                            handleClose={this.handleAddACCModal}
                            handleSnack={this.handleSnack}
                            isModal
                            // valuesToEdit={testObject}
                        />
                    }
                />
                <Snackbar
                    open={feedbackMessage.open}
                    variant={feedbackMessage.variant}
                    message={feedbackMessage.message}
                    handleClose={this.handleSnack}
                    vertical="top"
                    horizontal="right"
                    snackbarTop={'80px'}
                />
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => ({
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),
})

const AdminContactCenterCompose = compose(
    connect(null, mapDispatchToProps),
    withStyles(styles)
)(AdminContactCenter)

export default AdminContactCenterCompose;
